import { ReactElement, useContext } from 'react';
import { Dialog, DialogContent, DialogTitle, DialogProps, Breakpoint, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

import { ctxPopup } from '@/contexts/PopupContext';

import './Popup.css';

function PopupTitle({
  popupTitle,
  showNewHeader,
  leftText,
}: {
  popupTitle: string;
  showNewHeader: boolean;
  leftText: boolean;
}) {
  if (showNewHeader) {
    return (
      <div className="popup-base-header-title-temp">
        <h3>{popupTitle}</h3>
      </div>
    );
  } else {
    return (
      <div className="popup-base-header-title">
        {(leftText && (
          <h3 style={{ textAlign: 'left' }} data-qa-element-id="popup-header-title">
            {popupTitle}
          </h3>
        )) || <h3 data-qa-element-id="popup-header-title">{popupTitle}</h3>}
      </div>
    );
  }
}

function CloseComponent({ closePopup }: { closePopup: () => Promise<void> }) {
  return (
    <IconButton
      className="popup-base-header-close"
      aria-label="close"
      onClick={closePopup}
      sx={{ color: 'var(--mui-palette-text-primary)' }}
      data-qa-element-id="popup-close-button"
    >
      <CloseIcon />
    </IconButton>
  );
}

export function Popup({
  popupTitle,
  header,
  body,
  footer,
  closePopup,
  additionalClassName,
  size = 'md',
  fullHeight = true,
  isFullScr = false,
  showCloseButton = true,
  showNewHeader = false,
  leftText = false,
  hideBackdrop = true,
  isNewLookAvailable = false,
  scrollUnderHeaderView = false,
}: {
  popupTitle: string | undefined;
  header: ReactElement | undefined;
  body: ReactElement;
  footer: ReactElement | undefined;
  closePopup: () => Promise<void>;
  additionalClassName?: string;
  size?: Breakpoint;
  fullHeight?: boolean;
  isFullScr?: boolean;
  showCloseButton?: boolean;
  showNewHeader?: boolean;
  leftText?: boolean;
  hideBackdrop?: boolean;
  isNewLookAvailable?: boolean;
  scrollUnderHeaderView?: boolean;
}) {
  const scroll: DialogProps['scroll'] = 'paper';
  const popupCtx = useContext(ctxPopup);

  return (
    <Dialog
      fullScreen={isFullScr}
      fullWidth={true}
      maxWidth={size}
      open={true}
      onClose={closePopup}
      scroll={scroll}
      className="popup-base-whole"
      hideBackdrop={hideBackdrop}
      classes={{ paper: 'popup-base-whole-paper' }}
      {...(isNewLookAvailable &&
        !isFullScr && {
          slotProps: {
            paper: {
              sx: {
                margin: 0,
                maxWidth: '577px',
                position: 'fixed',
                left: `calc(${popupCtx?.drawerMenuOpen ? 250 : 70}px)`,
                m: 0,
                maxHeight: '95vh',
              },
            },
          },
        })}
    >
      {showCloseButton && <CloseComponent closePopup={closePopup} />}
      {popupTitle && <PopupTitle popupTitle={popupTitle} showNewHeader={showNewHeader} leftText={leftText} />}
      {header && (
        <DialogTitle
          id="scroll-dialog-title"
          className={`${additionalClassName === 'curved-background-color' ? 'popup-base-curved-header' : ''} popup-base-header`}
          sx={{ ...(scrollUnderHeaderView && { boxShadow: '0 4px 6px rgb(0 0 0 / 20%);', zIndex: 1 }) }}
        >
          {header}
        </DialogTitle>
      )}
      <DialogContent
        className={fullHeight ? 'popup-base-body-full-height' : ''}
        dividers={scroll === 'paper'}
        classes={{ root: additionalClassName, dividers: additionalClassName }}
      >
        {body}
      </DialogContent>
      {footer && <>{footer}</>}
    </Dialog>
  );
}
